import { gql } from "@apollo/client";

export const GET_CONTRACTS = gql`
  query GetContracts($filters: ContractFilters, $pagination: PaginationRequest) {
    contractQuery {
      list(filters: $filters, pagination: $pagination) {
        contracts {
          id
          sellerID
          seller {
            id
            fullName
          }
          code
          type
          startDate
          endDate
          status
          fileURL
          note
          drafterID
          drafterBy {
            id
            fullname
          }
          createdByID
          createdBy {
            id
            fullname
          }
          platformID
          createdAt
          updatedAt
          disabledAt
          disabledByID
        }
        paginationData {
          total
          offset
          limit
        }
      }
    }
  }
`;

export const GET_CONTRACT_DETAIL = gql`
  query GetContractDetail($id: ID!) {
    contractQuery {
      getByID(id: $id) {
        id
        sellerID
        seller {
          id
          fullName
          code
          sellerLevel {
            name
          }
          sellerGroup {
            id
            name
          }
        }
        code
        type
        startDate
        endDate
        status
        fileURL
        note
        drafterID
        drafterBy {
          id
          fullname
        }
        createdByID
        createdBy {
          id
          fullname
        }
        platformID
        createdAt
        updatedAt
        disabledAt
        disabledByID
      }
    }
  }
`;

